import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { GTM } from 'lib/external/gtm';
import { ROUTE_CHANGE_COMPLETE, ROUTE_CHANGE_START } from 'constants/constants';
import { setLoadingState } from 'app-redux/actions/appActions';

export const useRouteChangeCompleat = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChangeComplete = () => {
      const executeOnIdle = window.requestIdleCallback || setTimeout;

      executeOnIdle(() => {
        GTM.sendEvent('historyChange', {
          page_title: document.querySelector('title')?.innerText,
          page_location: window.location.href,
          page_path: window.location.pathname,
        });
      });
    };

    router.events.on(ROUTE_CHANGE_COMPLETE, handleRouteChangeComplete);

    return () => router.events.off(ROUTE_CHANGE_COMPLETE, handleRouteChangeComplete);
  }, [router]);
};

export const useRouteChangeStart = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleRouteChange = () => {
      dispatch(setLoadingState(true));
    };

    router.events.on(ROUTE_CHANGE_START, handleRouteChange);

    return () => {
      router.events.off(ROUTE_CHANGE_START, handleRouteChange);
    };
  }, [router, dispatch]);
};
